import type { Balances } from './tron';

/** Last known on-chain balances per address. Safe to show immediately on cold
 *  open (stale-while-revalidate); not a secret — amounts only. */
const KEY = 'asia:balances:v1';

type Entry = Balances & { at: number };
type Store = Record<string, Entry>;

function readStore(): Store {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Store;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function readBalanceCache(address: string): Balances | undefined {
  const hit = readStore()[address];
  if (!hit || typeof hit.usdt !== 'number' || typeof hit.trx !== 'number') return undefined;
  return { usdt: hit.usdt, trx: hit.trx };
}

export function writeBalanceCache(address: string, bal: Balances): void {
  try {
    const store = readStore();
    store[address] = { usdt: bal.usdt, trx: bal.trx, at: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(store));
  } catch {
    /* quota / private mode — skip */
  }
}
